import * as actionType from './type'

const INITIAL_STATE = {
    isLoading : false,
    ownerlist: [],
    currentuser: null,
    rolebasedData: null,
    organizationLabel: null,
    userList : [],
    Team: [],
    isFetchingUser: false,
}


export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.RECEIVED_USER: {
            return {
                ...state,
                ownerlist: action.payload
            }
        }

        // Fired at the start of requestgetcurrenctuser — signals that the API call is in-flight
        case actionType.REQUEST_CURRENT_USER: {
            return {
                ...state,
                isFetchingUser: true,
            }
        }

        case actionType.RECEIVED_CURRENT_USER: {
            return {
                ...state,
                isFetchingUser: false,
                currentuser: action.payload?.logeddata,
                rolebasedData: action.payload?.rolebasedData,
                organizationLabel: action?.payload?.organizationLabel
            }
        }

        case actionType.UPDATE_CURRENT_USER_PERMISSION: {
            return {
                ...state,
                rolebasedData: null
            }
        }
        case actionType.REQUEST_GET_USER: {
            return {
                ...state,
                isLoading: true
            }
        }
        case actionType.RECEIVED_SEARCHED_USER: {
            return {
                ...state,
                userList : action?.payload,
                isLoading : false
            }
        }

        case actionType.REQUEST_GET_MY_TEAM: {
            return {
                ...state,
                isLoading : true,
            }
        }
        case actionType.RECEIVED_MY_TEAM: {
            return {
                ...state,
                isLoading : false,
                Team : action?.payload
            }
        }

        case actionType.CLER_TEAM_EMPTY: {
            return {
                ...state,
                Team: []
            }
        }

        // Resets everything to initial state — clears currentUser, rolebasedData, isFetchingUser
        case actionType.LOGOUT: {
            return {
                ...INITIAL_STATE
            }
        }

        default: 
            return state;
    }
}